import { useLocation } from '@/services/router/compat';

export function getIsSettingsState(pathname: string) {
  const trimmedPathname = pathname.replace(/\/+$/, '');
  const normalizedPathname = trimmedPathname === '' ? '/' : trimmedPathname;
  const isAccountApiKeysPage = normalizedPathname === '/settings/api-keys';
  const isSettingsPage =
    normalizedPathname === '/settings' || (normalizedPathname.startsWith('/settings/') && !isAccountApiKeysPage);
  const isWorkspaceSettingsPage = /^\/workspaces\/(last|\d+)\/settings(\/|$)/.test(normalizedPathname);
  const isAnySettingsPage = isSettingsPage || isWorkspaceSettingsPage;

  return {
    isSettingsPage,
    isWorkspaceSettingsPage,
    isAnySettingsPage,
  };
}

export function useIsSettings() {
  const location = useLocation();
  return getIsSettingsState(location.pathname);
}
